import { Flex, Text } from '@chakra-ui/react'
import { Icon } from '@ubirider/pick-component-library'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthContext } from '../../../../AuthProvider'
import PickLogo from '../../../../assets/pick_logo.svg'

export const TopBar = props => {
  const { t } = useTranslation()
  const Auth = useContext(AuthContext)
  const user = Auth.user

  return (
    <>
      <Flex display={{ sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' }} justifyContent='space-between'>
        <Flex gap='12px' align='center'>
          <Icon src={PickLogo} css={{ width: 98, height: 31 }} fill='#7537FA' />
          <Text fontSize={{ sm: '16px', md: '16px', lg: '16px', xl: '16px' }} maxWidth='96px' lineHeight='16px' color='#7537FA'>
            {t('demo.my_mobility_account')}
          </Text>
        </Flex>
        <Flex gap='18px'>
          <Flex align='center' gap='18px'>
            <Text>
              {t('home.welcome')} {props.name ? props.name.split(' ')[0] : user.email}
            </Text>
          </Flex>
          <Flex align='center' gap='8px'>
            {/*<NotificationIcon notification={false} /> */}
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
